import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import './registerServiceWorker'
import vueDebounce from 'vue-debounce'
window.Pusher = require('pusher-js');

Vue.use(vueDebounce)

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    openSnackbar(text, color = '#696CFF') {
      this.$store.commit('setSnackbarStatus', true)
      this.$store.commit('setSnackbarText', text)
      this.$store.commit('setSnackbarColor', color)
    },
    showValidationErrors(errors) {
      let errorText = ''
      Object.entries(errors.response.data.errors).forEach((err) => {
        err[1].forEach((item) => {
          errorText = errorText + item + '<br>'
        })
      })
      this.openSnackbar(errorText, '#d40d45')
    },
    objectParametersToString(params) {
      let stringedParams = '';
      Object.entries(params).forEach((param) => {
        if (param[1]) {
          if (Array.isArray(param[1]) && param[1].length) {
            param[1].forEach((item) => {
              stringedParams = stringedParams + '&' + param[0] + '[]' + '=' + item
            })
          } else {
            stringedParams = stringedParams + '&' + param[0] + '=' + param[1]
          }
        }
      })
      return stringedParams;
    }
  },
})

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
